export default "__VITE_ASSET__0be53894__"